import { Check } from "lucide-react";
import { LOOP_STAGES, type LoopStage } from "@/platform/playbooks/types";
import { useLanguage } from "@/shared/i18n/LanguageContext";
import { counterpartsCopy } from "./copy";

/**
 * The signal line for one counterpart: four ticks, Prepare → Rehearse →
 * Report → Certified. State is carried by the mark AND the text — done ticks
 * hold a check, the current tick is filled and named "Next", upcoming ticks
 * are hollow — never by colour alone.
 */
export function LoopLine({
  stage,
  labelled = false,
}: {
  stage: LoopStage;
  labelled?: boolean;
}) {
  const { locale } = useLanguage();
  const copy = counterpartsCopy(locale);
  const current = LOOP_STAGES.indexOf(stage);
  return (
    <ol
      className={`eq-loop-line ${labelled ? "eq-loop-line--labelled" : ""}`}
      aria-label={`${copy.next}: ${copy.stages[stage]}`}
    >
      {LOOP_STAGES.map((item, index) => {
        const state =
          index < current ? "done" : index === current ? "current" : "upcoming";
        return (
          <li key={item} className={`eq-loop-tick is-${state}`}>
            <span className="eq-loop-mark" aria-hidden="true">
              {state === "done" && <Check size={10} strokeWidth={3} />}
            </span>
            {labelled ? (
              <span className="eq-loop-label">{copy.stages[item]}</span>
            ) : (
              <span className="sr-only">{copy.stages[item]}</span>
            )}
          </li>
        );
      })}
    </ol>
  );
}
